import { makeAutoObservable } from "mobx";
import {
    deleteMedicalEquipment,
    getMedicalEquipmentById,
    pagingMedicalEquipmentType,
    saveOrUpdateMedicalEquipment
} from 'app/services/MedicalEquipmentTypeService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";
import { downloadTemplateMedicalEquipmentType, importExcelMedicalEquipmentType } from "app/services/ImportExcelService";

const defaultValue = {
    code: "",
    name: "",
    isUsing: true
}
export default class MedicalEquipmentTypeStore {
    searchMedicalEquipment = new SearchObject();
    pageMedicalEquipment = null;
    selectedMedicalEquipment = defaultValue;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingMedicalEquipment = async () => {
        return await pagingMedicalEquipmentType(this.searchMedicalEquipment)
            .then(({ data }) => {
                this.pageMedicalEquipment = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu loại trang thiết bị có lỗi")
            })
    }

    handleChangeFormSearch = (searchMedicalEquipment) => {
        this.searchMedicalEquipment = checkSearchObject(this.searchMedicalEquipment, searchMedicalEquipment);
        this.pagingMedicalEquipment();
    }

    handleOpenFormCreateOrEdit = (medicalEquipmentId) => {
        if (Boolean(medicalEquipmentId)) {
            getMedicalEquipmentById(medicalEquipmentId).then(({ data }) => {
                this.selectedMedicalEquipment = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedMedicalEquipment = { ...defaultValue };
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateMedicalEquipment = (medicalEquipment, { setSubmitting }) => {
        saveOrUpdateMedicalEquipment(medicalEquipment)
            .then(() => {
                this.selectedMedicalEquipment = defaultValue;
                toast.success("Lưu thông tin thành công!");
                this.handleClosePopup();
                this.pagingMedicalEquipment();
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu thông tin có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (medicalEquipment) => {
        this.selectedMedicalEquipment = { id: medicalEquipment?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteMedicalEquipment(this.selectedMedicalEquipment?.id)
            .then(() => {
                if (this.searchMedicalEquipment?.pageIndex > 1 && this.pageMedicalEquipment?.content?.length === 1) {
                    this.searchMedicalEquipment.pageIndex -= 1;
                }
                toast.success("Xóa loại trang thiết bị thành công!");
                this.handleClosePopup();
                this.pagingMedicalEquipment();
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa loại trang thiết bị có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }
    handleDownloadExcelTemplate = async () => {
        try {
            const response = await downloadTemplateMedicalEquipmentType();

            if (response.status === 200) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "LOAI_TRANG_THIET_BI.xlsx");
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }
        } catch (error) {
            console.error("Error downloading template:", error);
        }
    }

    SubmitExcelMedicalEquipmentType = (file) => {
        importExcelMedicalEquipmentType(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchMedicalEquipment = {
                ...this.searchMedicalEquipment,
                pageIndex: 1
            }
            this.pagingMedicalEquipment()

        }).catch(() => {
            toast.error("Nhập excel thất bại")
        })
    }

    resetStore = () => {
        this.searchMedicalEquipment = new SearchObject();
        this.pageMedicalEquipment = null;
        this.selectedMedicalEquipment = defaultValue;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }
}
